import { Autocomplete, Box, Button, TextField } from "@mui/material";
import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Table } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import Swal from "sweetalert2";
import Pagination from "../../../components/Pagination/Pagination";
import DashboardDraft from "./DashboardDraft";
import DashboardExpired from "./DashboardExpired";
import TemplateModal from "./TemplateModal/TemplateModal";
import { useContext } from "react";
import { AdminContext } from "../../../Context/AdminContext";
import AddCategoryModal from "./AddCategoryModal";
import EditCategoryModal from "./EditCategoryModal";

const AddCategory = () => {
  const navigate = useNavigate();
  const { admin, setAdmin } = useContext(AdminContext);
  const [courses, setCourses] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [selectedTab, setSelectedTab] = useState("courses");
  const [id, setId] = useState("");
  const [templateModalOpen, setTemplateModalOpen] = useState(false);

  var newDate = new Date();
  let dd = String(newDate.getDate()).padStart(2, "0");
  let mm = String(newDate.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = newDate.getFullYear();
  let hh = newDate.getHours();
  let min = newDate.getMinutes();
  let ss = newDate.getSeconds();

  if (min < 10) {
    newDate = dd + "/" + mm + "/" + yyyy + "  " + hh + ":" + 0 + min + ":" + ss;
  } else {
    newDate = dd + "/" + mm + "/" + yyyy + "  " + hh + ":" + min + ":" + ss;
  }
  const pageHandle = (jump) => {
    // navigate(`/admin/products/${jump}`);
    setPageNumber(parseInt(jump));
  };
  console.log("courses", courses);

  useEffect(() => {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      },
    };

    const data = async () => {
      await axios
        .get(
          "https://backend.studyswiftly.com/api/v1/category/category",
          config
        )
        .then((res) => {
          setCourses(res.data.Categories);
        });
    };
    data();
  }, [refetch]);

  // Pagination
  const [pageNumber, setPageNumber] = useState(1);
  const [show, setShow] = useState(10);
  const [lastPage, setLastPage] = useState(0);
  const [sliceCourses, setSliceCourses] = useState([]);
  // console.log(sliceProducts)

  useEffect(() => {
    const lastPage = Math.ceil(courses?.length / show);
    setLastPage(lastPage);
  }, [courses, show]);

  useEffect(() => {
    if (pageNumber) {
      const page = parseInt(pageNumber);
      const getSlicingProduct = courses?.slice((page - 1) * show, page * show);
      setSliceCourses([...getSlicingProduct]);
      setPageNumber(parseInt(page));
    } else {
      const getSlicingProduct = courses?.slice(0, show);
      setSliceCourses([...getSlicingProduct]);
    }
  }, [courses, show, pageNumber]);

  const handleCourseDelete = (courseToDelete) => {
    // const confirmDelete = window.confirm('Are you sure, you want to delete this course?')

    Swal.fire({
      text: "Are you sure, you want to delete this category?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Yes",
      customClass: "modal_class_success",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(
            `https://backend.studyswiftly.com/api/v1/category/category/${courseToDelete?._id}`
          )
          .then((res) => {
            if (res.status === 200) {
              // alert(res.data.message);
              // swal({
              //     title: "Success",
              //     text: res.data.message,
              //     icon: "success",
              //     button: "OK!",
              //     className: "modal_class_success",
              // });

              const wrapper = document.createElement("div");
              // wrapper.innerHTML = `<p class='text-break text-white'>${res.data.message}</p>`;
              wrapper.innerHTML = `<p class='text-break text-white'>Category Deleted.</p>`;

              Swal.fire({
                html: wrapper,
                icon: "success",
                customClass: "modal_class_success",
              });

              setCourses(
                courses.filter((course) => course._id !== courseToDelete._id)
              );
            }
          })
          .catch((error) => {
            // alert(error.response.data.message);
            // swal({
            //     title: "Attention",
            //     text: error.response.data.message,
            //     icon: "warning",
            //     button: "OK!",
            //     className: "modal_class_success",
            // });

            const wrapper = document.createElement("div");
            wrapper.innerHTML = `<p class='text-break text-white'>${error.response.data.message}</p>`;

            Swal.fire({
              html: wrapper,
              icon: "warning",
              customClass: "modal_class_success",
            });
          });
      }
    });
  };

  const [modalShowNewAdmin, setModalShowNewAdmin] = useState(false);
  const [modalShowNewAdmin1, setModalShowNewAdmin1] = useState(false);

  const [isLoadingAdmin, setIsLoadingAdmin] = useState(false);
  const [isLoadingAdmin1, setIsLoadingAdmin1] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  return (
    // <div className='adminBody' style={{ height: "100vh" }}>
    <div className="adminBody">
      <h5 className="text-white text-start">CATEGORIES</h5>
      <div className="adminCard py-2">
        <div className="template-icon-button-container">
          {/* <button
            onClick={() => setTemplateModalOpen(true)}
            className="template-icon-button"
          >
            <FactCheckIcon />
          </button> */}
        </div>
        <div className="adminBtnDiv text-center">
          <AddCategoryModal
            show={modalShowNewAdmin}
            setIsLoadingAdmin={setIsLoadingAdmin}
            setModalShowNewAdmin={setModalShowNewAdmin}
            setRefetch={setRefetch}
            refetch={refetch}
            onHide={() => setModalShowNewAdmin(false)}></AddCategoryModal>
          <EditCategoryModal
            show={modalShowNewAdmin1}
            setIsLoadingAdmin={setIsLoadingAdmin1}
            setModalShowNewAdmin={setModalShowNewAdmin1}
            setRefetch={setRefetch}
            refetch={refetch}
            onHide={() => setModalShowNewAdmin1(false)}
            id={id}></EditCategoryModal>
          {/* <button
            onClick={() => navigate("/admin/addcourse")}
            className="adminBtn text-uppercase"
          >
            Add category
          </button> */}
          <button
            onClick={() => setModalShowNewAdmin(true)}
            className="adminBtn text-uppercase">
            Add new category
          </button>
        </div>
       <div className="container">
       <Autocomplete
          inputValue={categoryName}
          onInputChange={(event, newInputValue) => {
            setCategoryName(newInputValue);
          }}
          className="w-100"
          style={{ paddingBottom: "30px" }}
          options={courses}
          autoHighlight
          getOptionLabel={(option) => option.category_name}
          renderOption={(props, option) => (
            <Box component="li" {...props} key={option._id}>
              {option.category_name}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              className="bg-white rounded"
              {...params}
              label="Search course category"
              inputProps={{
                ...params.inputProps,
              }}
            />
          )}
        />
       </div>
        {selectedTab === "courses" && (
          <div className="tableNormal ">
            <Table className="text-white adminDataTable ">
              <thead>
                <tr>
                  <th className="text-start ps-4">No</th>
                  <th className="text-start">Name</th>
                  {/* <th className='text-start adminHidden'>End date</th> */}
                  <th className="text-start">Action</th>
                </tr>
              </thead>
              <tbody>
                {sliceCourses?.map((course, index) => (
                  <tr className="tableRow" key={course?._id}>
                    <td className="text-start ps-4"> {index + 1}</td>
                    <td className="text-start">{course?.name}</td>
                    {/* <td className='text-start adminHidden'>{`${course?.end?.slice(8, 10)}/${course?.end?.slice(5, 7)}/${course?.end?.slice(0, 4)}`}</td> */}
                    <td className="action">
                      <div className="actionDiv text-start">
                        <button
                          className="editBtn"
                          onClick={() => {
                            setId(course?._id);
                            setModalShowNewAdmin1(true);
                          }}>
                          <i className="fas fa-edit"></i>
                        </button>

                        <button
                          onClick={() => handleCourseDelete(course)}
                          className="deleteBtn">
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {sliceCourses?.length > 0 && (
              <div>
                <Pagination
                  lastPage={lastPage}
                  page={pageNumber}
                  pageHandle={pageHandle}
                />
              </div>
            )}
          </div>
        )}
        {selectedTab === "expired" && <DashboardExpired />}
        {selectedTab === "draft" && <DashboardDraft />}
      </div>

      <TemplateModal
        show={templateModalOpen}
        setTemplateModalOpen={setTemplateModalOpen}
        onHide={() => setTemplateModalOpen(false)}
      />
    </div>
  );
};

export default AddCategory;
